import { HELPER_BOT_BULLET_PRICE } from "../constants/helper";
import { BulletBotPlusInfo } from "../types/Contract/HelperBot/BulletBotPlusInfo";
import { HelperBotInfo } from "../types/Contract/HelperBot/HelperBotInfo";

export const calculateBulletBotRequiredCashAmount = (
  userBulletBotInfo: HelperBotInfo,
  userBulletBotPlusInfo: BulletBotPlusInfo
) => {
  const totalBulletAmount = calculateBulletBotGeneratedBulletAmount(
    userBulletBotInfo,
    userBulletBotPlusInfo
  );

  const cashAmount =
    (HELPER_BOT_BULLET_PRICE *
      totalBulletAmount *
      userBulletBotPlusInfo.priceModifiedPercent) /
    100;

  return cashAmount;
};

export const calculateBulletBotGeneratedBulletAmount = (
  userBulletBotInfo: HelperBotInfo,
  userBulletBotPlusInfo: BulletBotPlusInfo
) => {
  const totalBulletAmount =
    userBulletBotInfo.attemptCount *
    userBulletBotPlusInfo.amountModifiedPercent *
    5;

  return totalBulletAmount;
};
